import PasswordStrengthChecker from './container'
export { PasswordStrengthChecker }
export default PasswordStrengthChecker